import makeCrud from '@/store/site/localization/crud'
const module = makeCrud('manager_automation')
module.actions.catalog = async function () {
    const res = await this._vm.axios.get(this._vm.endpoint.get('manager_automation_catalog'))
    // İç veri objesini döndür ({catalog, lead_stages, customer_tags, segments, admin_groups})
    return res.data?.data ?? res.data
}
module.actions.toggle = async function (_, { id }) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('manager_automation') + '/' + id + '/toggle')
    return res.data
}
export default module
